import db from './database';

export const MaterialsService = {
    // Отримати всі типи матеріалів
    async getMaterialTypes() {
        const sql = `SELECT * FROM MaterialTypes ORDER BY name`;
        return db.executeQuery(sql);
    },

    // Отримати всі властивості
    async getProperties() {
        const sql = `SELECT * FROM Properties ORDER BY category, name`;
        return db.executeQuery(sql);
    },

    // Отримати всі застосування
    async getApplications() {
        const sql = `SELECT * FROM Applications ORDER BY industry, name`;
        return db.executeQuery(sql);
    },

    // Пошук матеріалів за типом
    async getMaterialsByType(typeName) {
        const sql = `
            SELECT 
                m.id, m.name, m.formula, m.density, m.description,
                mt.name as type
            FROM Materials m
            INNER JOIN MaterialTypes mt ON m.type_id = mt.id
            WHERE mt.name = ?
            ORDER BY m.name
        `;
        return db.executeQuery(sql, [typeName]);
    },

    // Пошук за властивостями
    async searchByProperty(propertyName, minValue, maxValue) {
        const sql = `
            SELECT 
                m.id, m.name, m.formula, m.density,
                mp.value, p.unit, p.name as property_name
            FROM Materials m
            INNER JOIN MaterialProperties mp ON m.id = mp.material_id
            INNER JOIN Properties p ON mp.property_id = p.id
            WHERE p.name = ?
              AND mp.value BETWEEN ? AND ?
            ORDER BY mp.value DESC
        `;
        return db.executeQuery(sql, [propertyName, minValue, maxValue]);
    },

    // Пошук за застосуванням
    async searchByApplication(applicationName) {
        const sql = `
            SELECT 
                m.id, m.name, m.formula, m.density,
                mt.name as type,
                ma.suitability, ma.notes
            FROM Materials m
            INNER JOIN MaterialTypes mt ON m.type_id = mt.id
            INNER JOIN MaterialApplications ma ON m.id = ma.material_id
            INNER JOIN Applications a ON ma.application_id = a.id
            WHERE a.name = ?
            ORDER BY 
                CASE ma.suitability
                    WHEN 'Excellent' THEN 1
                    WHEN 'Good' THEN 2
                    WHEN 'Fair' THEN 3
                    ELSE 4
                END
        `;
        return db.executeQuery(sql, [applicationName]);
    },

    // Отримати детальну інформацію про матеріал
    async getMaterialDetails(materialId) {
        // Основна інформація
        const materialSql = `
            SELECT 
                m.*, mt.name as type
            FROM Materials m
            INNER JOIN MaterialTypes mt ON m.type_id = mt.id
            WHERE m.id = ?
        `;
        const material = db.executeQuery(materialSql, [materialId])[0];
        
        if (!material) return null;
        
        // Елементний склад
        const compositionSql = `
            SELECT 
                e.symbol, e.name, mc.percentage
            FROM MaterialComposition mc
            INNER JOIN Elements e ON mc.element_id = e.id
            WHERE mc.material_id = ?
            ORDER BY mc.percentage DESC
        `;
        const composition = db.executeQuery(compositionSql, [materialId]);
        
        // Властивості
        const propertiesSql = `
            SELECT 
                p.name, mp.value, p.unit, p.category
            FROM MaterialProperties mp
            INNER JOIN Properties p ON mp.property_id = p.id
            WHERE mp.material_id = ?
            ORDER BY p.category, p.name
        `;
        const properties = db.executeQuery(propertiesSql, [materialId]);
        
        // Застосування
        const applicationsSql = `
            SELECT 
                a.name, a.industry, ma.suitability, ma.notes
            FROM MaterialApplications ma
            INNER JOIN Applications a ON ma.application_id = a.id
            WHERE ma.material_id = ?
        `;
        const applications = db.executeQuery(applicationsSql, [materialId]);
        
        return {
            ...material,
            composition,
            properties,
            applications
        };
    },

    // Статистика за типами
    async getStatisticsByType() {
        const sql = `
            SELECT 
                mt.name as type,
                COUNT(m.id) as count,
                ROUND(AVG(m.density), 2) as avg_density,
                ROUND(MIN(m.density), 2) as min_density,
                ROUND(MAX(m.density), 2) as max_density
            FROM MaterialTypes mt
            LEFT JOIN Materials m ON mt.id = m.type_id
            GROUP BY mt.id, mt.name
            ORDER BY count DESC
        `;
        return db.executeQuery(sql);
    },

    // Всі матеріали
    async getAllMaterials() {
        const sql = `
            SELECT 
                m.id, m.name, m.formula, m.density,
                mt.name as type
            FROM Materials m
            INNER JOIN MaterialTypes mt ON m.type_id = mt.id
            ORDER BY m.name
        `;
        return db.executeQuery(sql);
    }
};
